import { Button, Form, Input } from 'antd'
import { memo, useCallback } from 'react'
import { LeagueType } from 'types/league-types'

type Props = {
    leagueType: LeagueType
    onSubmit: (leagueType: LeagueType) => void
    loading: boolean
}

export const LeagueTypeForm = memo((props: Props) => {
    const { leagueType, onSubmit, loading } = props

    const onFinish = useCallback(
        (values: LeagueType) => {
            onSubmit(values)
        },
        [onSubmit]
    )

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={leagueType.name}
                label='Name'
                name='name'
                rules={[{ required: true, message: 'Please input league type name!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
